(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pierogi-include"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const heartIcon = (fill) => `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.56 19.124" aria-hidden="true" focusable="false">
        <path d="M19.913,5.967a5.015,5.015,0,0,0-7.094,0l-.967.967-.967-.967a5.016,5.016,0,1,0-7.094,7.094l.967.967,7.094,7.094,7.094-7.094.967-.967a5.015,5.015,0,0,0,0-7.094Z" transform="translate(-1.073 -3.247)" fill="${fill}" stroke="#e2b64c" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"></path>
      </svg>
    `;

    const parseLikes = (rawLikes) => {
      if (!rawLikes) return [];

      try {
        const parsedLikes = JSON.parse(rawLikes);
        return Array.isArray(parsedLikes) ? parsedLikes : [];
      } catch {
        return [];
      }
    };

    const escapeHtml = (value = '') =>
      value
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');

    const createEntryMarkup = ({ id, name, title, ingredients, notes, likes, customerEmail, customerLoggedIn }) => {
      const hasLiked = customerLoggedIn && customerEmail ? likes.includes(customerEmail) : false;
      const fill = hasLiked || (!customerLoggedIn && likes.length > 0) ? '#e2b64c' : 'none';
      const notesMarkup = notes
        ? `<p class="pierogi-include__notes paragraph">${escapeHtml(notes)}</p>`
        : '';

      return `
        <li class="pierogi-include__entry" data-entry-id="${escapeHtml(id)}">
          <article class="pierogi-include__card">
            <div class="pierogi-include__card-header">
              <div>
                <h3 class="h4 pierogi-include__card-title">${escapeHtml(title)}</h3>
                <p class="pierogi-include__person paragraph">${escapeHtml(name)}</p>
              </div>
            </div>
            <p class="pierogi-include__ingredients paragraph">${escapeHtml(ingredients)}</p>
            ${notesMarkup}
            <div class="pierogi-include__card-footer">
              <button
                type="button"
                class="button-unstyled pierogi-include__like-button"
                data-like-button
                data-id="${escapeHtml(id)}"
                ${customerLoggedIn ? '' : 'aria-disabled="true"'}
              >
                ${heartIcon(fill)}
                <span class="pierogi-include__like-count" data-like-count>${likes.length}</span>
              </button>
            </div>
          </article>
        </li>
      `;
    };

    const buildPayloadFields = (fields) =>
      fields.reduce((accumulator, field) => {
        accumulator[field.key] = field.value;
        return accumulator;
      }, {});

    const setMessage = (container, message, state = 'success') => {
      container.textContent = message;
      container.dataset.state = state;
    };

    const initSection = (sectionElement) => {
      if (!(sectionElement instanceof HTMLElement) || sectionElement.dataset.initialized === 'true') return;

      sectionElement.dataset.initialized = 'true';

      const apiUrl = sectionElement.dataset.apiUrl;
      const customerEmail = sectionElement.dataset.customerEmail || '';
      const customerLoggedIn = sectionElement.dataset.customerLoggedIn === 'true';
      const form = sectionElement.querySelector('[data-pierogi-form]');
      const submitButton = sectionElement.querySelector('[data-submit-button]');
      const shareButton = sectionElement.querySelector('[data-share-button]');
      const couponCodeInput = sectionElement.querySelector('[data-coupon-code]');
      const messageContainer = sectionElement.querySelector('[data-message-container]');
      const entriesContainer = sectionElement.querySelector('[data-pierogi-entries]');
      const emptyState = sectionElement.querySelector('[data-empty-state]');
      const loadingIndicator = sectionElement.querySelector('[data-loading-indicator]');

      if (
        !(form instanceof HTMLFormElement) ||
        !(submitButton instanceof HTMLButtonElement) ||
        !(shareButton instanceof HTMLButtonElement) ||
        !(couponCodeInput instanceof HTMLInputElement) ||
        !(messageContainer instanceof HTMLElement) ||
        !(entriesContainer instanceof HTMLElement) ||
        !(emptyState instanceof HTMLElement) ||
        !(loadingIndicator instanceof HTMLElement)
      ) {
        return;
      }

      let cursor = '';
      let hasMoreData = true;
      let isLoading = false;
      const renderedIds = new Set();

      const updateEmptyState = () => {
        emptyState.classList.toggle('hidden', entriesContainer.children.length > 0 || isLoading);
      };

      const toggleLoading = (loading) => {
        isLoading = loading;
        loadingIndicator.classList.toggle('hidden', !loading);
        updateEmptyState();
      };

      const appendEntries = (edges) => {
        const fragment = document.createDocumentFragment();

        edges.forEach((edge) => {
          const node = edge?.node;
          const metaobjectId = node?.id;
          const fields = Array.isArray(node?.fields) ? buildPayloadFields(node.fields) : {};

          if (!metaobjectId || renderedIds.has(metaobjectId) || fields.approved_decline !== 'true') return;

          const ingredients = [fields.ingredient_1, fields.ingredient_2, fields.ingredient_3]
            .filter(Boolean)
            .join(', ');
          const likes = parseLikes(fields.likes_count);
          const wrapper = document.createElement('div');

          wrapper.innerHTML = createEntryMarkup({
            id: metaobjectId,
            name: fields.name || 'Anonymous',
            title: fields.name_your_pierogi || 'Untitled idea',
            ingredients,
            notes: fields.notes_or_add_ons || '',
            likes,
            customerEmail,
            customerLoggedIn,
          }).trim();

          const entry = wrapper.firstElementChild;
          if (!entry) return;

          renderedIds.add(metaobjectId);
          fragment.append(entry);
        });

        entriesContainer.append(fragment);
        updateEmptyState();
      };

      const fetchEntries = async () => {
        if (!apiUrl || isLoading || !hasMoreData) return;

        toggleLoading(true);

        try {
          const response = await fetch(`${apiUrl}/show_form_data.php?cursor=${encodeURIComponent(cursor)}`, {
            headers: {
              Accept: 'application/json',
            },
          });

          if (!response.ok) throw new Error(`Request failed with status ${response.status}`);

          const data = await response.json();
          const edges = Array.isArray(data?.edges) ? data.edges : [];
          const pageInfo = data?.pageInfo || {};

          appendEntries(edges);

          cursor = pageInfo.endCursor || '';
          hasMoreData = Boolean(pageInfo.hasNextPage ?? pageInfo.endCursor);
        } catch {
          setMessage(messageContainer, 'There was an error loading submissions. Please try again later.', 'error');
          hasMoreData = false;
        } finally {
          toggleLoading(false);
        }
      };

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        if (!apiUrl) {
          setMessage(messageContainer, 'The submission endpoint is not configured.', 'error');
          return;
        }

        submitButton.disabled = true;
        const formData = new URLSearchParams(new FormData(form)).toString();
        const body = new URLSearchParams({
          formData,
          coupon_code: couponCodeInput.value,
        });

        try {
          const response = await fetch(`${apiUrl}/add_form_data.php`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body,
          });

          if (!response.ok) throw new Error(`Request failed with status ${response.status}`);

          form.reset();
          setMessage(messageContainer, 'Thank you for your submission!');
        } catch {
          setMessage(messageContainer, 'There was an error processing your request. Please try again.', 'error');
        } finally {
          submitButton.disabled = false;
        }
      });

      shareButton.addEventListener('click', async () => {
        const shareData = {
          title: document.title,
          url: window.location.href,
        };

        try {
          if (navigator.share) {
            await navigator.share(shareData);
            return;
          }

          await navigator.clipboard.writeText(window.location.href);
          setMessage(messageContainer, 'Page link copied to clipboard.');
        } catch {
          setMessage(messageContainer, 'Unable to share this page right now.', 'error');
        }
      });

      entriesContainer.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-like-button]');

        if (!(button instanceof HTMLButtonElement) || !customerLoggedIn || !customerEmail || !apiUrl) return;
        if (button.disabled) return;

        button.disabled = true;

        try {
          const body = new URLSearchParams({
            metaobject_id: button.dataset.id || '',
            user_email: customerEmail,
          });
          const response = await fetch(`${apiUrl}/update_likes_count.php`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body,
          });

          if (!response.ok) throw new Error(`Request failed with status ${response.status}`);

          const data = await response.json();
          const likeCount = button.querySelector('[data-like-count]');
          const heart = button.querySelector('path');

          if (likeCount) {
            likeCount.textContent = `${data.count ?? 0}`;
          }

          if (heart instanceof SVGPathElement) {
            heart.setAttribute('fill', data.fill || 'none');
          }
        } catch {
          setMessage(messageContainer, 'There was an error updating your vote. Please try again.', 'error');
        } finally {
          button.disabled = false;
        }
      });

      const handleScroll = () => {
        if (!hasMoreData || isLoading) return;

        const footer = document.querySelector('.footer');
        if (!(footer instanceof HTMLElement)) return;

        const footerTop = footer.getBoundingClientRect().top + window.scrollY;
        const windowBottom = window.scrollY + window.innerHeight;

        if (windowBottom >= footerTop - 500) {
          fetchEntries();
        }
      };

      fetchEntries();
      window.addEventListener('scroll', handleScroll, { passive: true });
    };

    const initAllSections = (root = document) => {
      root.querySelectorAll('[data-pierogi-include]').forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllSections(), { once: true });
    } else {
      initAllSections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof HTMLElement) {
        initAllSections(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
